import { useEffect, useState } from "react";
import api, { apiErr } from "../lib/api";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Clock, Send } from "lucide-react";

export default function Settings() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => { api.get("/config").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  const save = async () => {
    try { const { data } = await api.put("/config", cfg); setCfg(data); toast.success("Impostazioni salvate"); }
    catch (e) { toast.error(apiErr(e)); }
  };
  if (!cfg) return null;

  return (
    <div className="space-y-5 max-w-2xl">
      <h1 className="font-display text-3xl text-lm-text">Impostazioni</h1>

      <div className="lm-card p-6 space-y-4">
        <div className="flex items-center gap-2 text-lm-brown"><Clock className="w-5 h-5" /><h2 className="font-display text-xl">Orario limite richieste</h2></div>
        <p className="text-sm text-lm-text2">Le richieste inserite dopo questo orario per il giorno successivo verranno evidenziate alla logistica.</p>
        <div className="max-w-xs">
          <Label className="text-xs text-lm-text2">Orario limite</Label>
          <Input data-testid="cfg-cutoff" value={cfg.cutoff_time} onChange={(e) => setCfg((c) => ({ ...c, cutoff_time: e.target.value }))} placeholder="16:00" className="mt-1 bg-white" />
        </div>
      </div>

      <div className="lm-card p-6 space-y-4">
        <div className="flex items-center gap-2 text-lm-brown"><Send className="w-5 h-5" /><h2 className="font-display text-xl">Modalità di pubblicazione giri</h2></div>
        <div className="max-w-xs">
          <Label className="text-xs text-lm-text2">Pubblicazione</Label>
          <Select value={cfg.publish_mode} onValueChange={(v) => setCfg((c) => ({ ...c, publish_mode: v }))}>
            <SelectTrigger data-testid="cfg-publish" className="mt-1 bg-white"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="con_conferma">Con conferma del responsabile</SelectItem>
              <SelectItem value="auto">Automatica per i giri senza conflitti</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <p className="text-xs text-lm-muted">In modalità <b>automatica</b>, quando generi una proposta i giri con mezzo e autista assegnati, senza criticità e senza appuntamenti a rischio vengono pubblicati subito; quelli critici restano da confermare a mano. Dopo la pubblicazione, ogni modifica a un giro viene evidenziata e notificata all'autista.</p>
      </div>

      <Button data-testid="save-config-btn" onClick={save} className="bg-lm-brown hover:bg-lm-brownh text-lm-cream">Salva impostazioni</Button>
    </div>
  );
}
